var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('object-list-renderer',{attrs:{"value":_vm.value,"entity-id":_vm.params.entityId,"on-grid":""},on:{"reload":function($event){return _vm.$emit('reload')}}})}
var staticRenderFns = []

export { render, staticRenderFns }